export default "dist/images/block-pricing-box-colored.70f7b32.png";